/* global Symbol */
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import ButtonGroup from '../../../../../../common/components/c_ButtonGroup';
import ProgressComponent from '../../../../../../common/components/C_ProgressComponent';

// js utilities
import _ from 'lodash';

// class name
// import cx from 'classnames';

@connect(store => ({
  labels: _.get(store.labels, 'Application.background.professionalAssociations', {}),
}), null, null, {withRef: true})
export default class ProfessionalAssociations extends ProgressComponent {
  static propTypes = {
    user: PropTypes.object,
    profileId: PropTypes.number.isRequired,
    associations: PropTypes.object.isRequired,
    model: PropTypes.string.isRequired,
    viewState: PropTypes.object,
    tempState: PropTypes.object.isRequired,
    updateTempState: PropTypes.func.isRequired,
  }

  static defaultProps = {
    user: {}
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      validation: Object.assign(
        this.CustomValidation,
        _.pick(props.validation, [])
      )
    };
  }

  get CustomValidation() {
    const comp = this;
    const CustomValidator = function() {
      const model = () => Object.assign({}, _.get(comp, 'props.associations'), _.get(comp, `props.tempState[${comp.props.model}]`));
      this.associations = {
        custom: {
          func: (val) => !_.isEmpty(_.filter(model(), (s) => s.deleted !== Symbol.for('_deleted_'))) || !_.isEmpty(val),
          message: 'Must Select at Least One'
        }
      };
    };

    return new CustomValidator();
  }

  onChange(event, value) {
    value = _.map(value, str => _.replace(str, /\[/g, '(').replace(/\]/g, ')'));
    const diff = _.difference(_.keysIn(this.props.associations), value);
    const newAssociations = _.reduce(value.concat(diff), (associations, assoc) => {
        associations[assoc] = {name: assoc, deleted: diff.includes(assoc) ? Symbol.for('_deleted_') : null};
        return associations;
      }, {});

    this.props.updateTempState(`${this.props.model}`, null, null, newAssociations);
  }

  render() {
    const values = _.keysIn(_.pickBy(_.get(this.props.tempState, [this.props.model], this.props.associations || {}), s => !s.deleted));
    let list = _.map(_.orderBy(this.props.staticData.professionalAssociationTypes, ['name'], ['asc']), a => ({primaryText:a.name}));
    list.unshift({primaryText: 'None'});

    return (
      <div className='application-section-container clearfix'>
        <div
          className='form-heading'
          data-id={'Professional Associations title'}>
          {_.get(this.props.labels, 'Professional Associations title', 'Professional Associations')}
        </div>
        <div className='associations-instructions'>
          {_.get(this.props.labels, 'associations-instructions', 'Please select the Professional Associations of which you are a member.')}
        </div>
        <ButtonGroup
          menuItems={list}
          value={values}
          validation={this.props.validation[this.props.validationKey]}
          onErrorChange={this.props.errorUpdate}
          onChange={::this.onChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Background/c_ProfessionalAssociations/index.js